// src/env.ts

// Fetch `api_config.json`
// This will block and log and error if it doesn't succeed.
// This is a temporary fix to solve timing issues. There is a task (86d0av795) logged for a better fix.
const base_url = import.meta.env.BASE_URL === "/" ? "/" : `${import.meta.env.BASE_URL}/`;
const response = await fetch(`${base_url}api_config.json`);
if (!response.ok) {
  console.error("Could not fetch api_config");
}

export const api_config = await response.json();

// If the user hasn't set a keykloak url, skip authentication
export const SKIP_AUTH: boolean = !api_config.keycloak_url;
